module.exports = __webpack_public_path__ + "img/google-qibla-finder-01.c5eb9e3e.jpg";